export const ConsumerAssetSubtypeViewUat = {
  submitButton: 'workflow.consumerAssetSubtype.submit.button',
  assetSubtypeSelect: 'workflow.consumerAssetSubtype.assetSubtypeSelect',
  assetSubtypeItem: 'workflow.consumerAssetSubtype.assetSubtypeItem',
}
